import { useEffect } from "react";

const APP_NAME = "GridRecruiter";
const DEFAULT_TITLE = "GridRecruiter | Recrutamento e Seleção com IA";

/**
 * Update document.title for the current page. Restores the previous title
 * on unmount so the global default in index.html shows up again when no
 * page sets one.
 *
 * Usage:
 *   useDocumentTitle("Vagas");                 → "Vagas · GridRecruiter"
 *   useDocumentTitle(job?.title, { ready: !!job }); // wait for data
 *   useDocumentTitle(null);                    → resets to default
 *
 * Options:
 *   - ready (default true): when false, doesn't change the title yet.
 *     Useful while page data is still loading to avoid title flicker
 *     ("undefined · GridRecruiter" then jumping to the real one).
 *   - exact (default false): when true, sets `title` as-is without the
 *     " · GridRecruiter" suffix. Use for public-facing pages where the
 *     brand isn't the focus.
 */
export default function useDocumentTitle(title, { ready = true, exact = false } = {}) {
  useEffect(() => {
    if (!ready) return undefined;

    const previous = document.title;
    if (title) {
      const clean = String(title).trim();
      document.title = exact ? clean : `${clean} · ${APP_NAME}`;
    } else {
      document.title = DEFAULT_TITLE;
    }

    return () => {
      document.title = previous;
    };
  }, [title, ready, exact]);
}
